import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { ConfirmareRelatieService } from '../confirmare-relatie.service';
import { ConfirmareRelatieAddPayload } from '../confirmare-relatie.interface';

@Component({
    selector: 'app-add-confirmare-relatie',
    templateUrl: './add-confirmare-relatie.component.html',
    styleUrls: ['./add-confirmare-relatie.component.scss']
})
export class AddConfirmareRelatieComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        color: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddConfirmareRelatieComponent>,
        private requestService: ConfirmareRelatieService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description, color } = this.form
            .value as ConfirmareRelatieAddPayload;
        const payload: ConfirmareRelatieAddPayload = {
            name,
            slug,
            description,
            color,
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
